import { Component, input } from '@angular/core';
import { KENDO_CHIP } from '@progress/kendo-angular-buttons';
import { KENDO_LOADER, KENDO_SKELETON } from '@progress/kendo-angular-indicators';
import { KENDO_POPOVER } from '@progress/kendo-angular-tooltip';
import { DateTimezonePipe } from '@unity/pipes/date-timezone.pipe';
import { AuditDto } from '@unity/utils/types';

@Component({
  selector: 'unity-chip-audit-popup-shared',
  imports: [KENDO_CHIP, KENDO_POPOVER, KENDO_SKELETON, KENDO_LOADER, DateTimezonePipe],
  templateUrl: './chip-audit-popup-shared.component.html',
  styleUrl: './chip-audit-popup-shared.component.scss',
})
export class ChipAuditPopupSharedComponent {
  public readonly $data = input.required<AuditDto | undefined>({ alias: 'data' });
}
